import {
    Button,
    IconButton,
    InputAdornment,
    MenuItem,
    Select,
    Switch,
    TextField,
    Typography,
} from '@mui/material';
import StepsConfiguration from './StepsConfiguration';
import { useEffect, useState } from 'react';

const CLICK_ACTIONS = [
    {
        id: 'direct_link',
        text: 'Direct Link',
    },
    {
        id: 'open_modal',
        text: 'Open Modal',
    },
];


const ICON_PACK = [
    { name: "peat", url: "https://peoplejoy-media.s3.us-east-1.amazonaws.com/CustomProductSplash_Icons/EducationAccessTool_Icon.svg" },
    { name: 'ahn_crna', url: "https://peoplejoy-media.s3.us-east-1.amazonaws.com/CustomProductSplash_Icons/AHN_CRNA_Icon.svg" },
    { name: "ahn_gnlr", url: "https://peoplejoy-media.s3.us-east-1.amazonaws.com/CustomProductSplash_Icons/AHN_GNLR_Icon.svg" },
    { name: "ahn_iilf", url: "https://peoplejoy-media.s3.us-east-1.amazonaws.com/CustomProductSplash_Icons/AHN_IILF_Icon.svg" },
    { name: "ahn_son", url: "https://peoplejoy-media.s3.us-east-1.amazonaws.com/CustomProductSplash_Icons/AHN_SON_Icon.svg" },
    { name: "ahn_tapp", url: "https://peoplejoy-media.s3.us-east-1.amazonaws.com/CustomProductSplash_Icons/AHN_TAPP_Icon.svg" },
    { name: "cfp", url: "https://peoplejoy-media.s3.us-east-1.amazonaws.com/CustomProductSplash_Icons/CFP_Icon.svg" },
    { name: "pslf", url: "https://peoplejoy-media.s3.us-east-1.amazonaws.com/CustomProductSplash_Icons/PSLF_Icon.svg" },
    { name: "slra", url: "https://peoplejoy-media.s3.us-east-1.amazonaws.com/CustomProductSplash_Icons/SLRA_Icon.svg" },
    { name: "trs", url: "https://peoplejoy-media.s3.us-east-1.amazonaws.com/CustomProductSplash_Icons/TRS_Icon.svg" }

]


const ProductConfiguration = ({ product, onChange, errors = {} }) => {
    const [selectedIcon, setSelectedIcon] = useState(null);
    const [openStepsModal, setOpenStepsModal] = useState(false);

    useEffect(() => {
        if (product?.iconUrl) {
            const icon = ICON_PACK.find((icon) => icon.url === product.iconUrl);
            if (icon) setSelectedIcon(icon.name);
        }
    }, [product]);

    const handleInputChange = (name, value) => {
        if (name === 'clickAction') {
            onChange(product.name, {
                ...product,
                [name]: value,
                steps: [],
                directLinkUrl: '',
            });
        } else {
            onChange(product.name, {
                ...product,
                [name]: value,
            });
        }
    };

    const renderClickActionUI = (action) => {
        if (action === 'direct_link') {
            return (
                <TextField
                    value={product.directLinkUrl || ''}
                    onChange={(e) => handleInputChange('directLinkUrl', e.target.value)}
                    error={!!errors.directLinkUrl}
                    helperText={errors.directLinkUrl}
                    variant='outlined'
                    fullWidth
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position='start'>
                                <Typography color='textSecondary'>https://</Typography>
                            </InputAdornment>
                        ),
                    }}
                />
            );
        }
        if (action === 'open_modal') {
            return (
                <Button onClick={() => setOpenStepsModal(true)} variant='outlined'>
                    Add Steps
                </Button>
            );
        }
        return null;
    };

    const handleProductSteps = (steps) => handleInputChange('steps', steps);

    const handleSelectIcon = (name) => {
        setSelectedIcon(name);
        const icon = ICON_PACK.find((icon) => icon.name === name);
        handleInputChange("iconUrl", icon.url);
    }

    return (
        <div className='mt-2'>
            <div className='mb-3 nice'>
                <label>Display Name</label>
                <TextField
                    name='title'
                    value={product?.title || ''}
                    onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                    error={!!errors.title}
                    helperText={errors.title}
                    fullWidth
                />
            </div>
            <div className='nice mb-3'>
                <label>Display Description</label>
                <TextField
                    name='description'
                    value={product?.description || ''}
                    onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                    error={!!errors.description}
                    helperText={errors.description}
                    multiline
                    rows={5}
                    fullWidth
                />
            </div>
            <div className='d-flex align-items-center justify-content-between mb-3'>
                <label>Display Info Banner</label>
                <Switch
                    size='medium'
                    color='primary'
                    checked={product?.infoBannerEnabled}
                    onChange={(e) =>
                        handleInputChange('infoBannerEnabled', e.target.checked)
                    }
                />
            </div>

            {product?.infoBannerEnabled && (
                <>
                    <TextField
                        label='Info Banner Text'
                        variant='outlined'
                        fullWidth
                        className='mb-3'
                        name='infoBannerText'
                        value={product?.infoBannerText || ''}
                        onChange={(e) => handleInputChange(e.target.name, e.target.value)}
                    />
                    {errors.infoBannerText && (
                        <Typography color='error' variant='body2' className='mb-2'>
                            {errors.infoBannerText}
                        </Typography>
                    )}
                </>
            )}
            <span>Click Actions</span>
            <div className='d-flex align-items-start justify-content-between mb-3'>
                <Select
                    style={{ minWidth: 300 }}
                    value={product?.clickAction || ''}
                    onChange={(e) => handleInputChange('clickAction', e.target.value)}
                    error={!!errors.clickAction}
                >
                    <MenuItem value=''>
                        <em>Select</em>
                    </MenuItem>
                    {CLICK_ACTIONS.map((opt) => (
                        <MenuItem key={opt.id} value={opt.id}>
                            {opt.text}
                        </MenuItem>
                    ))}
                </Select>

                <div className='flex-grow-1 ml-3'>
                    {renderClickActionUI(product?.clickAction)}
                </div>
            </div>
            {errors?.steps && (
                <Typography color='error' variant='body2' className='mb-2'>
                    {errors.steps}
                </Typography>
            )}

            {(product?.steps || []).length > 0 && (
                <div className='mt-3 w-100'>
                    <Typography variant='subtitle1' gutterBottom>
                        Added Steps
                    </Typography>
                    {product?.steps.map((step, idx) => (
                        <div
                            key={idx}
                            style={{
                                border: '1px solid #ddd',
                                borderRadius: 8,
                                padding: '8px 12px',
                                marginBottom: 8,
                                background: '#fafafa',
                            }}
                        >
                            <Typography variant='body2' fontWeight='bold'>
                                Step {idx + 1}: {step.title}
                            </Typography>
                            <Typography variant='body2' color='primary'>
                                {step.url}
                            </Typography>
                            <Typography variant='body2' color='textSecondary'>
                                {step.description}
                            </Typography>
                        </div>
                    ))}
                </div>
            )}

            {product.name.includes('custom_product') && (
                <>
                    <div>
                        <p>Choose Background Color</p>
                        <input
                            type="color"
                            value={product.color}
                            onChange={(e) => handleInputChange("color", e.target.value)}
                            style={{ width: "50px", height: "50px", border: "none", cursor: "pointer" }}
                        />
                        {errors?.color && (
                            <Typography color='error' variant='body2' className='mb-2'>
                                {errors.color}
                            </Typography>
                        )}

                    </div>
                    <div>
                        <p>Select Icon</p>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
                            {ICON_PACK.map((icon) => (
                                <IconButton
                                    key={icon.name}
                                    onClick={() => handleSelectIcon(icon.name)}
                                    style={{
                                        border: selectedIcon === icon.name ? "2px solid #1976d2" : "2px solid transparent",
                                        borderRadius: "8px",
                                        margin: "4px",
                                        padding: "4px",

                                    }}
                                >
                                    <img className="w-full h-full object-contain" src={icon.url} alt={`Icon for ${icon.name}`} />
                                </IconButton>
                            ))}
                        </div>
                        {errors?.iconUrl && (
                            <Typography color='error' variant='body2' className='mb-2'>
                                {errors.iconUrl}
                            </Typography>
                        )}
                    </div>
                </>

            )}
            {openStepsModal && (
                <StepsConfiguration
                    productSteps={product?.steps ?? []}
                    onSave={handleProductSteps}
                    close={setOpenStepsModal}
                />
            )}
        </div>
    );
};

export default ProductConfiguration;